import './QuestionAnswers.css';


function QuestionAnswers({answers, footerContent}) {



  if(!answers || answers.length === 0) {
    return (
      <div className="question-answers-section empty">
        <div className="question-answers empty"></div>
      </div>
    );
  }

  return (
    <div className="question-answers-section">
      <div className="question-answers">
        {answers?.map((answer) => {
          return (
            <div className="question-answers-item" key={answer.id}>
              <pre className="question-answers-item-content">{answer.choices[0].message.content}</pre>
            </div>
          )
        }
        )}
      </div>
      <div className="question-answers-footer" dangerouslySetInnerHTML={{__html: footerContent}}>
      </div>
    </div>
    
  );
}

export default QuestionAnswers;
